import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/SideMenu.css'; // SideMenu 스타일 사용

// 일반 아이콘 import
import workerIcon from '../assets/images/worker-icon.png';
import noticeIcon from '../assets/images/notice-icon.png';
import contractIcon from '../assets/images/contract-icon.png';
import overtimeIcon from '../assets/images/overtime-icon.png';
import planIcon from '../assets/images/plan-icon.png';
import paymentIcon from '../assets/images/payment-icon.png';

// 활성화된 아이콘 import
import workerIconActive from '../assets/images/worker-icon-active.png';
import noticeIconActive from '../assets/images/notice-icon-active.png';
import contractIconActive from '../assets/images/contract-icon-active.png';
import overtimeIconActive from '../assets/images/overtime-icon-active.png';
import planIconActive from '../assets/images/plan-icon-active.png';
import paymentIconActive from '../assets/images/payment-icon-active.png';

// 추가된 아이콘 import
import activeIcon from '../assets/images/insurance-icon-active.png';
import inactiveIcon from '../assets/images/insurance-icon.png';
import customerIcon from '../assets/images/customer-icon.png';
import customerIconActive from '../assets/images/customer-icon-active.png';

const SideMenu = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const menuItems = [
    {
      path: '/dashboard/worker-management',
      label: '근로자 정보 관리',
      icon: workerIcon,
      activeIcon: workerIconActive
    },
    {
      path: '/dashboard/notices',
      label: '공지사항 관리',
      icon: noticeIcon,
      activeIcon: noticeIconActive
    },
    {
      path: '/dashboard/contract-settings',
      label: '계약 정보 설정',
      icon: contractIcon,
      activeIcon: contractIconActive
    },
    {
      path: '/dashboard/overtime-settings',
      label: '특근 수당 조건 설정',
      icon: overtimeIcon,
      activeIcon: overtimeIconActive
    },
    {
      path: '/dashboard/plan-management',
      label: '나의 플랜 관리',
      icon: planIcon,
      activeIcon: planIconActive
    },
    {
      path: '/dashboard/payment',
      label: '결제내역',
      icon: paymentIcon,
      activeIcon: paymentIconActive
    },
    {
      path: '/dashboard/store-info',
      label: '지점 정보 관리',
      icon: inactiveIcon,
      activeIcon: activeIcon
    },
    {
      path: '/dashboard/customer-support',
      label: '고객지원',
      icon: customerIcon,
      activeIcon: customerIconActive
    },
  ];

  return (
    <div className="sideMenu">
      {menuItems.map((item) => (
        <Link 
          key={item.path}
          to={item.path} 
          className={`menuItem ${currentPath.includes(item.path) ? 'active' : ''}`}
        >
          <img 
            src={currentPath.includes(item.path) ? item.activeIcon : item.icon} 
            alt={item.label} 
            className="menuIcon" 
          />
          <span>{item.label}</span>
        </Link>
      ))}
    </div>
  );
};

export default SideMenu; 